import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import { tooltipStyles } from '@constants/mui-theme';

const CustomTooltip = withStyles(() => ({
  tooltip: {
    backgroundColor: tooltipStyles.backgroundColor,
    borderRadius: tooltipStyles.borderRadius,
    color: tooltipStyles.color,
    fontFamily: tooltipStyles.fontFamily,
    fontSize: tooltipStyles.fontSize,
    lineHeight: tooltipStyles.lineHeight,
    padding: tooltipStyles.padding
  }
}))(Tooltip);

export default CustomTooltip;
